export { default as DeleteTeamModal } from './DeleteTeamModal';
